import Slide, { SlideProps } from '@ixigo/iui/Slide';
import { forwardRef } from 'react';

const DesktopSlide = forwardRef((props: SlideProps, ref) => <Slide {...props} direction='right' ref={ref} />);

export default DesktopSlide;
